export const LOCK_UNLOCK_TYPES = {
    UNLOCKED: 'DISABLED',
    LOCKED: 'ENABLED',
};

export const getLockStatusByBool = (bool) => (bool ? LOCK_UNLOCK_TYPES.LOCKED : LOCK_UNLOCK_TYPES.UNLOCKED);
export const getBoolByLockStatus = (status) => status === LOCK_UNLOCK_TYPES.LOCKED;
